/**
 * adCreate tea相关 store
 */
export default {
  namespaced: true,
  state: {
    startData: {
      action_ad_level: '', // 来源的广告层级: campaign, ad_group, ad
      create_mode: 'create', // 创编类型：create、edit、duplicate
    },
    finishData: {
      from_url_path: '',
      finish_type: '', // submit_success 创建成功 exit 退出
      start_point: '', // 来源的广告层级: campaign, ad_group, ad
      action_ad_level: '', // 结束的广告层级: campaign, ad_group, ad
      duration_campaign: null, // campaign层级耗时 s
      duration_ad_group: null, // ad group 层级耗时 s
      duration_ad: null, //
      campaign_objective: '', // campaign的objective类型，app_install, traffic, conversion, reach, video_view, catalogue_sales
      create_mode: '', // 创编类型：create、edit、duplicate
      start_time: '', // 创编初始时间
      edit_time: '', // 每次路由发生变化的时间
    },
  },
  mutations: {
    commitStartData(state, data) {
      state.startData = {
        ...state.startData,
        ...data,
      };
    },
    commitFinishData(state, data) {
      state.finishData = {
        ...state.finishData,
        ...data,
      };
    },
    commitClearFinishData(state) {
      // eslint-disable-next-line no-return-assign
      Object.keys(state.finishData).forEach(key => state.finishData[key] = '');
    },
  },
  actions: {
    setStartData({ commit }, data) {
      commit('commitStartData', data || {});
    },
    setFinishData({ commit }, data) {
      commit('commitFinishData', data || {});
    },
    clearFinishData({ commit }) {
      commit('commitClearFinishData');
    },
  },
};
